import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import {
	createPlan,
	createPlanFailure,
	createPlanSuccess,
	getEnabledPlans,
	getEnabledPlansSuccess,
	getEnabledPlansFailure,
	getPlans,
	getPlansSuccess,
	getPlansFailure,
	getPlanByName,
	getPlanByNameSuccess,
	getPlanByNameFailure,
	getPlanByClientId,
	getPlanByClientIdFailure,
	getPlanByClientIdSuccess,
} from '.';

import planService from '../../../services/PlanService';

function* rootSaga() {
	yield takeLatest(createPlan, createPlanSaga);
	yield takeLatest(getEnabledPlans, getEnabledPlansSaga);
	yield takeLatest(getPlans, getPlansSaga);
	yield takeLatest(getPlanByName, getPlanByNameSaga);
	yield takeLatest(getPlanByClientId, getPlanByClientIdSaga);
}

function* createPlanSaga({ payload }) {
	try {
		yield delay(300);
		const createdCompany = yield call(planService.createPlan, payload);
		yield put(createPlanSuccess(createdCompany));
		const tableParams = yield select(({ plans }) => plans.plans.tableParams);
		yield put(getPlans(tableParams));
	} catch (error) {
		yield put(createPlanFailure(error));
	}
}

function* getEnabledPlansSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(planService.getAllEnabled, payload);
		yield put(getEnabledPlansSuccess(response));
	} catch (error) {
		yield put(getEnabledPlansFailure(error));
	}
}

function* getPlansSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(planService.getAll, payload);
		yield put(getPlansSuccess(response));
	} catch (error) {
		yield put(getPlansFailure(error));
	}
}

function* getPlanByNameSaga({ payload }) {
	try {
		yield delay(300);
		const plan = yield call(planService.getByName, payload);
		yield put(getPlanByNameSuccess(plan));
	} catch (error) {
		yield put(getPlanByNameFailure(error));
	}
}

function* getPlanByClientIdSaga({ payload }) {
	try {
		yield delay(300);
		const plan = yield call(planService.getPlanByClientId, payload);
		yield put(getPlanByClientIdSuccess(plan));
	} catch (error) {
		yield put(getPlanByClientIdFailure(error));
	}
}

export default rootSaga;
